// универсальная точка входа во Vue приложение
import Vue from 'vue';
import { sync } from 'vuex-router-sync';
import App from './App.vue';
import { createRouter } from './router';
import { createStore } from './store';
import kit from './components/kit/kit';
import VueMeta from './plugins/vue-meta';
import VueTouchEvents from './plugins/vue-touch-events';
import utils from './plugins/utils';
import cities from './plugins/cities'
import createI18n from './plugins/i18n';
import { createFetcher } from './api/fetcher';
import createApi from './api/entry-api';
import Adaptive from '@/utils/adaptive';

// глобально регистрируем UIkit
Vue.use(kit);

Vue.use(VueMeta);
Vue.use(VueTouchEvents);

// экспортируем функцию-фабрику для создания экземпляров нового приложения с роутером и стором
export function createApp ({ SESSION_TOKEN = '', device, STATIC_URL } = {}, API_URL) {
  if(STATIC_URL) {
    // eslint-disable-next-line no-undef
    __webpack_public_path__ = STATIC_URL;
  }
  // создаем новые экземпляры роутера и стора
  const router = createRouter();
  const store = createStore();
  const i18n = createI18n();
  const adaptive = new Adaptive(device);

  // синхронизируем чтобы состояние маршрута было доступно как часть хранилища
  // убить, можно роутер в стор прокинуть сразу
  sync(store, router);

  store.$api = createApi(createFetcher(SESSION_TOKEN, API_URL), store);
  store.$router = router;

  Vue.use(utils, { router, store, adaptive });
  Vue.use(cities, { store, adaptive });

  // создаем новый экземпляр приложения, с внедренными роутером и стором
  const app = new Vue({
    provide: {
      adaptive,
    },
    router,
    i18n,
    store,
    render: r => r(App),
  });

  // возвращаем новое приложение, роутер и стор
  return {
    app,
    router,
    store,
  }
}
